import { PrivateDeploy } from '@/config/private-deploy'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let constantRoutes = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/news',
        name: 'news',
        component: () => import('@/pages/content/index.vue'),
        meta: {
            pageMode: 'paas-page'
        },
    },
    {
        path: '/newsDetail/:id',
        name: 'newsDetail/:id',
        component: () => import('@/templates/content/newsDetail.vue'),
        meta: {
            pageMode: 'paas-page'
        },
    },
    {
        path: '/m-news',
        component: () => import('@/pages/m-content/index.vue'),
        meta: {
            pageMode: 'paas-page'
        },
    },
    {
        path: '/m-newsDetail/:id',
        component: () => import('@/templates/m-content/m-newsDetail.vue'),
        meta: {
            pageMode: 'paas-page'
        },
    },
    {
        path: '/overdue',
        component: () => import('@/pages/error/overdue'),
    },
    {
        path: '/site-not-page',
        component: () => import('@/pages/error/site-not-page'),
    },
    {
        path: '/account',
        name: 'Account',
        component: () => import('@/pages/account'),
        meta: {
            pageMode: 'paas-page'
        },
    },
]

if(PrivateDeploy.isPrivate()){
    constantRoutes = constantRoutes.concat(PrivateDeploy.getPrivateRoutes())
}

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export default router



// WEBPACK FOOTER //
// ./src/router/index.js